import { render, staticRenderFns } from "./GrupoPermissaoForm.vue?vue&type=template&id=06c183d1&scoped=true"
import script from "./GrupoPermissaoForm.vue?vue&type=script&lang=js"
export * from "./GrupoPermissaoForm.vue?vue&type=script&lang=js"
import style0 from "./GrupoPermissaoForm.vue?vue&type=style&index=0&id=06c183d1&prod&scoped=true&lang=css"
import style1 from "./GrupoPermissaoForm.vue?vue&type=style&index=1&id=06c183d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c183d1",
  null
  
)

export default component.exports